export default [
  {
    text: "Actions",
    value: "actions",
    width: "60px",
    sortable: false,
    order: 6,
    hidable: true,
    hidden: false,
  },
  {
    text: "Name",
    value: "firstName",
    width: "250px",
    sortable: true,
    order: 1,
    hidable: false,
    hidden: false,
  },

  {
    text: "Email",
    value: "email",
    sortable: false,
    order: 2,
    hidable: true,
    hidden: false,
  },

  {
    text: "Create Date",
    value: "createDate",
    width: "150px",
    sortable: true,
    order: 3,
    hidable: true,
    hidden: false,
  },
  {
    text: "Update Date",
    value: "updateDate",
    width: "150px",
    sortable: true,
    order: 4,
    hidable: true,
    hidden: false,
  },
  {
    text: "Status",
    value: "isExpired",
    width: "120px",
    sortable: true,
    order: 5,
    hidable: true,
    hidden: false,
  },
];
